import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import React from 'react';
import {VideoRetryScreenTileBox} from "./video-retry-screen-boxes/video-retry-screen-tile.box";
import {VideoRetryScreenIconBox} from "./video-retry-screen-boxes/video-retry-screen-icon.box";
import {SvgSizeUnit} from "../../../../basic-ui-components/icon/svg-icon/svg.icon";
import {VideoRetryScreenTitleBox} from "./video-retry-screen-boxes/video-retry-screen-title.box";
import {VideoRetryScreenTextBox} from "./video-retry-screen-boxes/video-retry-screen-text.box";
import {Button} from "../../../../basic-ui-components/button/base/button.component";

export interface VideoRetryScreenComponentProps {
    retryFn: () => void;
    setHasError: (value: boolean, retryFn?: (() => void) | undefined) => void;
}

export default class VideoRetryScreenComponent extends OrbitComponent<VideoRetryScreenComponentProps> {

    private _retryAndSetError = () => {
        if (this.props.retryFn) {
            this.props.retryFn();
        }
        this.props.setHasError(false);
    };

    render(): React.ReactNode {
        const BrokenLinkIcon = this.services.theme.currentTheme.icons.brokenLinkIcon;

        return (
            <VideoRetryScreenTileBox>
                <VideoRetryScreenIconBox>
                    <BrokenLinkIcon size={4} sizeUnit={SvgSizeUnit.Rem}/>
                </VideoRetryScreenIconBox>
                <VideoRetryScreenTitleBox>
                    {this.services.translation.translate('CANT_CONNECT_ERROR_TITLE')}
                </VideoRetryScreenTitleBox>
                <VideoRetryScreenTextBox>
                    {this.services.translation.translate('CANT_CONNECT_ERROR_MESSAGE')}
                </VideoRetryScreenTextBox>
                <Button preset={"primary"} sizeVariant={"small"} onClick={this._retryAndSetError}>
                    {this.services.translation.translate('RETRY')}
                </Button>
            </VideoRetryScreenTileBox>
        )
    }
}
